import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../../utils/api';
import { postArchiveDataEndpoint } from '../../../common/endpoints';

export const postArchiveData = createApi(postArchiveDataEndpoint, 'POST');

const Archive = createSlice({
  name: 'Archive',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(postArchiveData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(postArchiveData.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(postArchiveData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default Archive.reducer;